import * as React from 'react';
import {Button, Col, Row} from 'reactstrap';
import Panel from '../../../theme/components/Panel';
import Table from '../../../theme/components/table/Table';
import DownloadIcon from 'mdi-react/DownloadIcon';
import {localNumber} from '../../../utils/number-utils';
import {mirana, util} from '@wize/mirana-proto/mirana-proto';

interface TdosTableProps {
    indicadores: mirana.IIndicador[];
    periodo?: string;
    handleGenerarExcel: () => {};
    descargaHabilitada: boolean;
}

class TdosTable extends React.PureComponent<TdosTableProps> {

    private get resumen() {
        return <Row>
            <Col md={3} lg={3}>
                <h4 className='bold-text' style={{textAlign: 'center'}}>
                    <strong>Fecha: {this.props.periodo}</strong>
                </h4>
            </Col>
            <Col md={{size: 1, offset: 8}} lg={{size: 1, offset: 8}}>
                <Button outline={true} className='icon icon--only' onClick={this.props.handleGenerarExcel}
                        color='primary'
                        disabled={!this.props.descargaHabilitada}><DownloadIcon/></Button>
            </Col>
        </Row>;
    }

    public resultados = (resultados: util.IKeyValueDay[] | null | undefined) => {
        const content: any[] = [];
        if (resultados) {
            resultados.forEach((res, index) => {
                content.push(<td key={`cob-resultado-${index}`}
                                 style={{textAlign: 'right'}}>{localNumber(Number(res.value))}</td>)
            });
        }
        return content;
    };

    private get indicadoresCabecera() {
        const content: any[] = [];
        if (this.props.indicadores && this.props.indicadores.length > 0) {
            const first = this.props.indicadores[0];
            if (first && first.resultados) {
                first.resultados.forEach((res, index) => {
                    content.push(<th key={`cob-header-${index}`}>{res.key}</th>)
                });
            }
        }
        return content;
    }

    private get indicadoresFilas() {
        const content: any[] = [];
        if (this.props.indicadores) {
            this.props.indicadores.forEach((indicador, index) => {
                if (index === 0 || index === 5) {
                    content.push((
                        <tr key={`indicador-${index}`}>
                            <td>{index === 0 ? 'KPI T2 VALOR' : 'KPI RECHAZOS SOLES'}</td>
                            <td>{indicador.definicion}</td>
                            {this.resultados(indicador.resultados)}
                        </tr>));
                } else if (index === 1 || index === 3) {
                    content.push((
                        <tr key={`indicador-${index}`}>
                            <td rowSpan={2}>{index === 1 ? 'KPI COBERTURA CLIENTES' : 'KPI EFECTIVIDAD PRE VENTA'}</td>
                            <td>{indicador.definicion}</td>
                            {this.resultados(indicador.resultados)}
                        </tr>));
                } else {
                    content.push((
                        <tr key={`indicador-${index}`}>
                            <td>{indicador.definicion}</td>
                            {this.resultados(indicador.resultados)}
                        </tr>));
                }
            });
        }

        return content;
    }

    public render() {
        return (
            <Panel xs={12} md={12} divider={true} title='Indicadores Diarios'>
                {this.resumen}
                {this.props.indicadores.length > 0 ? <Table responsive={true} className='table--bordered'>
                    <thead>
                    <tr>
                        <th>KPI</th>
                        <th>DEFINICI&Oacute;N</th>
                        {this.indicadoresCabecera}
                    </tr>
                    </thead>
                    <tbody>
                    {this.indicadoresFilas}
                    </tbody>
                </Table> : null}
            </Panel>
        )
    }
}

export default TdosTable;



// WEBPACK FOOTER //
// ./src/components/pages/tdos/tdos-table.tsx